define('plugin/client-field/validator/ValidatorClientFields',['require','lib/validator/ValidatorAbstract'],function (require) {

	var ValidatorAbstract = require('lib/validator/ValidatorAbstract');
	
	return ValidatorAbstract.extend({
        
        options: {
            error: 'error_value_is_empty'
        },
		
		/**
		 * Validates value
		 *  
		 * @param mixed value
		 */
		validate: function (value) {
            var errors = {};
            this.options.fields_collection.each(function (fieldModel) {
                var fieldErrors = fieldModel.validate()
                if (fieldErrors) {
                    errors[fieldModel.get('name')] = fieldModel.get('error');
                }
            });
            
            if (!_.isEmpty(errors)) {
                this.addError(errors);
                console.log(errors);
            }
            
		}
	
	});
	
});
